// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Taken from https://stackoverflow.com/a/29888724 */
.vertical-range-slider {
  margin-top: 50px;
  transform: rotate(270deg);
}
`, "",{"version":3,"sources":["webpack://./src/ViewContextManager/GlobalVolume.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,gBAAgB;EAChB,yBAAyB;AAC3B","sourcesContent":["/* Taken from https://stackoverflow.com/a/29888724 */\n.vertical-range-slider {\n  margin-top: 50px;\n  transform: rotate(270deg);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
